module.exports = __webpack_public_path__ + "static/media/Rainbow_Loved.ae3cc4ce.gif";